module.exports = __webpack_public_path__ + "img/refrigeracion.3864fc02.png";